<template>
  <v-container fluid>
    <v-row no-gutters align="center" :justify="justify_report" class="pr-1 pl-2">
      <v-col cols="12" v-if="is_tester">
        <DialogVT />
      </v-col>
      <v-col cols="12" v-if="show_export_btn">
        <v-fab-transition>
          <!-- $store.state.show_right_nav_bar -->
          <v-btn class="export-btn" color="vtred" @click="exportToPDF" large dark fixed bottom right fab>
            <v-icon>mdi-export</v-icon>
          </v-btn>
        </v-fab-transition>
        <div class="schedule">
          <v-btn
            class="mr-1 schedule-btn"
            color="vtblue"
            @click="openSchedulingPopup"
            small
            fixed
            right
            dark
            :disabled="is_tester"
          >
            {{ $t("common.words.schedule") }}
            <v-icon small>mdi-account-clock-outline</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col :class="{ ' mb-4': show_export_btn }" cols="12">
        <v-card :color="`${!show_export_btn ? 'backgroundLight' : ''}`" :class="{ 'mx-2 pa-2': show_export_btn }" flat>
          <v-row align="center" :justify="justify_report">
            <v-col
              :class="{
                'border-doc pa-1': show_export_btn,
                'pa-0': !show_export_btn,
              }"
              cols="auto"
            >
              <div class="container-width backgroundWhite" style="background-color: #ffffff">
                <div ref="header">
                  <img height="200" width="794px" id="header" src="/assets/images/header.png" />
                </div>
                <div id="document" ref="document">
                  <PowerDataMainReport />
                </div>
                <div ref="footer">
                  <img height="50" width="794px" id="footer" src="/assets/images/footer.png" />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-overlay class="layering" :value="dialog">
        <v-card
          :light="!this.$vuetify.theme.dark"
          class="backgroundWhite"
          style="width: 80vw; max-height: 80vh; overflow: auto"
        >
          <div class="close-btn">
            <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
              <v-icon small color="primaryGrey">mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="pa-0" style="overflow: auto; height: 100%">
            <ReportManagement :isPowerData="isPowerData" />
          </div>
        </v-card>
      </v-overlay>
    </v-row>
  </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";
import PowerDataMainReport from "../components/PowerDataMainReport";
import ReportManagement from "../components/ReportManagement";
import DialogVT from "../components/DialogVT";

export default {
  name: "PowerdataReports",
  components: {
    PowerDataMainReport,
    ReportManagement,
    DialogVT,
  },
  data: function () {
    return {
      dialog: false,
      isPowerData: true,
      tabs: [
        {
          label: "Net Zero",
          value: "NetZero",
        },
        {
          label: "Power Quality",
          value: "PowerQuality",
        },
      ],
      current_tab: "NetZero",
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    openSchedulingPopup() {
      this.dialog = true;
    },
    pdfCallback(pdfObject) {
      var pdf_pages = pdfObject.internal.pages;
      var myFooter = "Footer info";
      for (var i = 1; i < pdf_pages.length; i++) {
        // We are telling our pdfObject that we are now working on this page
        pdfObject.setPage(i);
        // The 10,100 value is only for A4 portrait.
        pdfObject.text(myFooter, 10, 100);
      }
    },
    update_current_tab(tab) {
      this.current_tab = tab;
    },
    exportToPDF() {
      //this.$store.commit("show_loader");
      var opt = {
        margin: [1.8, 0, 1, 0],
        filename: "report_" + new Date().toString() + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          dpi: 190,
          letterRendering: true,
        },
        jsPDF: { unit: "in", format: "a4", orientation: "p" },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };
      html2pdf()
        .from(this.$refs.document)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            if (i == 1) {
              pdf.addImage(document.getElementById("header"), "png", 0, 0, 8.27, 2);
            }
            pdf.addImage(
              document.getElementById("footer"),
              "png",
              0,
              pdf.internal.pageSize.getHeight() - 0.4,
              8.27,
              0.4
            );
          }
        })
        .save();
      this.$store.commit("hide_loader");
    },
  },
  computed: {
    is_tester: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY];
      return role && role.length > 0 && role.indexOf("Tester") != -1 ? true : false;
    },
    show_alerts: function () {
      return (
        this.$store.state.tenant_config.show_alerts_section &&
        ("alerts_enabled" in this.$store.state.user_config ? this.$store.state.user_config.alerts_enabled : true)
      );
    },
    justify_report: function () {
      return this.$route.name == "Report_Snapshot" ? "left" : "center";
    },
    show_export_btn: function () {
      return this.$route.name == "Report_Snapshot" ? false : true;
    },
    updated_current_tab: function () {
      let tab =
        this.$route.name == "report_fleet"
          ? "NetZero"
          : this.$route.name == "report_kpi"
            ? "PowerQuality"
            : this.current_tab;
      return tab;
    },
    customer_type: function () {
      return this.$store.state.tenant_config.powerdata_type;
    },
  },
};
</script>
<style scoped lang="scss">
.container-width {
  width: 794px;
  overflow-x: visible;
  overflow-y: auto;

  ::v-deep a {
    color: #0581c6 !important;
  }
}

.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}

.schedule {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}

.schedule-btn,
.export-btn {
  z-index: 9;
  &.alerts-open {
    right: 410px;
  }
  &.alerts-close {
    right: 60px;
  }
}
</style>
